var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { attrs: { id: "telnyx-settings" } }, [
    _c("div", { staticClass: "page-header" }, [
      _vm._m(0),
      _vm._v(" "),
      _c(
        "div",
        { staticClass: "right" },
        [
          _c(
            "a-button",
            {
              attrs: { type: "primary", loading: _vm.testing },
              on: { click: _vm.testConnection },
            },
            [_vm._v(" Bağlantıyı Test Et ")]
          ),
        ],
        1
      ),
    ]),
    _vm._v(" "),
    _c("div", { staticClass: "settings-content" }, [
      _c("div", { staticClass: "settings-section" }, [
        _vm._m(1),
        _vm._v(" "),
        _c(
          "div",
          { staticClass: "section-content" },
          [
            _c(
              "a-form",
              { attrs: { layout: "vertical" } },
              [
                _c(
                  "a-form-item",
                  { attrs: { label: "Kanal Adı" } },
                  [
                    _c("a-input", {
                      attrs: { placeholder: "Kanal adını girin" },
                      on: { change: _vm.handleChange },
                      model: {
                        value: _vm.localChannel.name,
                        callback: function ($$v) {
                          _vm.$set(_vm.localChannel, "name", $$v)
                        },
                        expression: "localChannel.name",
                      },
                    }),
                  ],
                  1
                ),
              ],
              1
            ),
          ],
          1
        ),
      ]),
      _vm._v(" "),
      _c("div", { staticClass: "settings-section" }, [
        _vm._m(2),
        _vm._v(" "),
        _c(
          "div",
          { staticClass: "section-content" },
          [
            _c(
              "a-form",
              { attrs: { layout: "vertical" } },
              [
                _c(
                  "a-row",
                  { attrs: { gutter: 16 } },
                  [
                    _c(
                      "a-col",
                      { attrs: { span: 12 } },
                      [
                        _c(
                          "a-form-item",
                          { attrs: { label: "Username" } },
                          [
                            _c("a-input", {
                              attrs: { placeholder: "Telnyx kullanıcı adınız" },
                              on: { change: _vm.handleChange },
                              model: {
                                value: _vm.localChannel.payload.username,
                                callback: function ($$v) {
                                  _vm.$set(
                                    _vm.localChannel.payload,
                                    "username",
                                    $$v
                                  )
                                },
                                expression: "localChannel.payload.username",
                              },
                            }),
                          ],
                          1
                        ),
                      ],
                      1
                    ),
                    _vm._v(" "),
                    _c(
                      "a-col",
                      { attrs: { span: 12 } },
                      [
                        _c(
                          "a-form-item",
                          { attrs: { label: "Password" } },
                          [
                            _c("a-input-password", {
                              attrs: { placeholder: "Telnyx şifreniz" },
                              on: { change: _vm.handleChange },
                              model: {
                                value: _vm.localChannel.payload.password,
                                callback: function ($$v) {
                                  _vm.$set(
                                    _vm.localChannel.payload,
                                    "password",
                                    $$v
                                  )
                                },
                                expression: "localChannel.payload.password",
                              },
                            }),
                          ],
                          1
                        ),
                      ],
                      1
                    ),
                  ],
                  1
                ),
                _vm._v(" "),
                _c(
                  "a-form-item",
                  { attrs: { label: "Caller Phone Number" } },
                  [
                    _c("a-input", {
                      attrs: { placeholder: "Örn: +18445420900" },
                      on: { change: _vm.handleChange },
                      model: {
                        value: _vm.localChannel.payload.callerPhoneNumber,
                        callback: function ($$v) {
                          _vm.$set(
                            _vm.localChannel.payload,
                            "callerPhoneNumber",
                            $$v
                          )
                        },
                        expression: "localChannel.payload.callerPhoneNumber",
                      },
                    }),
                  ],
                  1
                ),
              ],
              1
            ),
          ],
          1
        ),
      ]),
      _vm._v(" "),
      _c("div", { staticClass: "settings-section" }, [
        _vm._m(3),
        _vm._v(" "),
        _c(
          "div",
          { staticClass: "section-content" },
          [
            _c(
              "a-alert",
              {
                attrs: {
                  message: "Webhook URL",
                  type: "info",
                  "show-icon": "",
                },
              },
              [
                _c(
                  "div",
                  { attrs: { slot: "description" }, slot: "description" },
                  [
                    _c(
                      "div",
                      { staticClass: "webhook-info" },
                      [
                        _c("span", { staticClass: "webhook-url" }, [
                          _vm._v(_vm._s(_vm.getWebhookAddress())),
                        ]),
                        _vm._v(" "),
                        _c(
                          "a-button",
                          {
                            staticStyle: { padding: "0", "margin-left": "8px" },
                            attrs: {
                              type: "link",
                              size: "small",
                              icon: "copy",
                            },
                            on: { click: _vm.copyWebhookAddress },
                          },
                          [
                            _vm._v(
                              "\n                                Kopyala\n                            "
                            ),
                          ]
                        ),
                      ],
                      1
                    ),
                    _vm._v(" "),
                    _c("div", { staticClass: "webhook-description" }, [
                      _vm._v(
                        "\n                            Bu URL'yi Telnyx panelinizdeki webhook ayarlarında kullanın. \n                            Telnyx'den gelen call event'leri bu endpoint'e yönlendirilecek.\n                        "
                      ),
                    ]),
                  ]
                ),
              ]
            ),
          ],
          1
        ),
      ]),
      _vm._v(" "),
      _c("div", { staticClass: "settings-section" }, [
        _vm._m(4),
        _vm._v(" "),
        _c(
          "div",
          { staticClass: "section-content" },
          [
            _c(
              "a-form",
              { attrs: { layout: "vertical" } },
              [
                _c(
                  "a-form-item",
                  { attrs: { label: "Domain" } },
                  [
                    _c("a-input", {
                      attrs: { placeholder: "sip.telnyx.com" },
                      on: { change: _vm.handleChange },
                      model: {
                        value: _vm.localChannel.payload.domain,
                        callback: function ($$v) {
                          _vm.$set(_vm.localChannel.payload, "domain", $$v)
                        },
                        expression: "localChannel.payload.domain",
                      },
                    }),
                  ],
                  1
                ),
                _vm._v(" "),
                _c(
                  "a-form-item",
                  { attrs: { label: "WebSocket Server" } },
                  [
                    _c("a-input", {
                      attrs: { placeholder: "wss://sip.telnyx.com:7443" },
                      on: { change: _vm.handleChange },
                      model: {
                        value: _vm.localChannel.payload.websocketServer,
                        callback: function ($$v) {
                          _vm.$set(
                            _vm.localChannel.payload,
                            "websocketServer",
                            $$v
                          )
                        },
                        expression: "localChannel.payload.websocketServer",
                      },
                    }),
                  ],
                  1
                ),
                _vm._v(" "),
                _c(
                  "a-form-item",
                  { attrs: { label: "API Key" } },
                  [
                    _c("a-input-password", {
                      attrs: { placeholder: "API Key" },
                      on: { change: _vm.handleChange },
                      model: {
                        value: _vm.localChannel.payload.apiKey,
                        callback: function ($$v) {
                          _vm.$set(_vm.localChannel.payload, "apiKey", $$v)
                        },
                        expression: "localChannel.payload.apiKey",
                      },
                    }),
                  ],
                  1
                ),
              ],
              1
            ),
          ],
          1
        ),
      ]),
      _vm._v(" "),
      _c("div", { staticClass: "settings-section" }, [
        _vm._m(5),
        _vm._v(" "),
        _c("div", { staticClass: "section-content" }, [
          _c("div", { staticClass: "status-grid" }, [
            _c("div", { staticClass: "status-item" }, [
              _c("div", { staticClass: "status-label" }, [
                _vm._v("Kanal Durumu"),
              ]),
              _vm._v(" "),
              _c(
                "div",
                { staticClass: "status-value" },
                [
                  _c(
                    "a-tag",
                    { attrs: { color: _vm.value.enabled ? "green" : "red" } },
                    [
                      _vm._v(
                        "\n                                " +
                          _vm._s(_vm.value.enabled ? "Aktif" : "Pasif") +
                          "\n                            "
                      ),
                    ]
                  ),
                ],
                1
              ),
            ]),
            _vm._v(" "),
            _c("div", { staticClass: "status-item" }, [
              _c("div", { staticClass: "status-label" }, [
                _vm._v("Oluşturma Tarihi"),
              ]),
              _vm._v(" "),
              _c("div", { staticClass: "status-value" }, [
                _vm._v(
                  "\n                            " +
                    _vm._s(
                      _vm
                        .$moment(_vm.value.createdAt)
                        .format("DD.MM.YYYY HH:mm")
                    ) +
                    "\n                        "
                ),
              ]),
            ]),
            _vm._v(" "),
            _c("div", { staticClass: "status-item" }, [
              _c("div", { staticClass: "status-label" }, [
                _vm._v("Son Güncelleme"),
              ]),
              _vm._v(" "),
              _c("div", { staticClass: "status-value" }, [
                _vm._v(
                  "\n                            " +
                    _vm._s(
                      _vm
                        .$moment(_vm.value.updatedAt)
                        .format("DD.MM.YYYY HH:mm")
                    ) +
                    "\n                        "
                ),
              ]),
            ]),
            _vm._v(" "),
            _c("div", { staticClass: "status-item" }, [
              _c("div", { staticClass: "status-label" }, [_vm._v("Kanal ID")]),
              _vm._v(" "),
              _c(
                "div",
                { staticClass: "status-value channel-id" },
                [
                  _c("span", [_vm._v(_vm._s(_vm.value._id))]),
                  _vm._v(" "),
                  _c(
                    "a-button",
                    {
                      attrs: { type: "link", size: "small", icon: "copy" },
                      on: { click: _vm.copyChannelId },
                    },
                    [
                      _vm._v(
                        "\n                                Kopyala\n                            "
                      ),
                    ]
                  ),
                ],
                1
              ),
            ]),
          ]),
        ]),
      ]),
      _vm._v(" "),
      _c("div", { staticClass: "settings-section danger-zone" }, [
        _vm._m(6),
        _vm._v(" "),
        _c("div", { staticClass: "section-content" }, [
          _c("div", { staticClass: "danger-actions" }, [
            _c(
              "div",
              { staticClass: "danger-item" },
              [
                _vm._m(7),
                _vm._v(" "),
                _c(
                  "a-button",
                  {
                    attrs: {
                      type: _vm.value.enabled ? "danger" : "primary",
                      loading: _vm.toggleLoading,
                    },
                    on: { click: _vm.toggleChannelStatus },
                  },
                  [
                    _vm._v(
                      "\n                            " +
                        _vm._s(
                          _vm.value.enabled ? "Devre Dışı Bırak" : "Aktif Et"
                        ) +
                        "\n                        "
                    ),
                  ]
                ),
              ],
              1
            ),
            _vm._v(" "),
            _c(
              "div",
              { staticClass: "danger-item" },
              [
                _vm._m(8),
                _vm._v(" "),
                _c(
                  "a-button",
                  {
                    attrs: { type: "danger" },
                    on: {
                      click: function ($event) {
                        return _vm.$router.push("/integrations/webphone/telnyx")
                      },
                    },
                  },
                  [
                    _vm._v(
                      "\n                            Kanalı Sil\n                        "
                    ),
                  ]
                ),
              ],
              1
            ),
          ]),
        ]),
      ]),
    ]),
  ])
}
var staticRenderFns = [
  function () {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "left" }, [
      _c("h3", [_vm._v("Telnyx Ayarları")]),
      _vm._v(" "),
      _c("p", [_vm._v("Telnyx kanalınızın bağlantı ayarlarını düzenleyin")]),
    ])
  },
  function () {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "section-header" }, [
      _c("h4", [_vm._v("Kanal Bilgileri")]),
      _vm._v(" "),
      _c("p", [_vm._v("Kanal adı ve açıklama bilgileri")]),
    ])
  },
  function () {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "section-header" }, [
      _c("h4", [_vm._v("Telnyx Hesap Bilgileri")]),
      _vm._v(" "),
      _c("p", [_vm._v("Telnyx hesabınızın giriş bilgileri")]),
    ])
  },
  function () {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "section-header" }, [
      _c("h4", [_vm._v("Webhook Ayarları")]),
      _vm._v(" "),
      _c("p", [_vm._v("Telnyx panelinde webhook URL'sini yapılandırın")]),
    ])
  },
  function () {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "section-header" }, [
      _c("h4", [_vm._v("Bağlantı Ayarları")]),
      _vm._v(" "),
      _c("p", [_vm._v("SIP sunucu bağlantı bilgileri")]),
    ])
  },
  function () {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "section-header" }, [
      _c("h4", [_vm._v("Durum Bilgileri")]),
      _vm._v(" "),
      _c("p", [_vm._v("Kanalın mevcut durumu")]),
    ])
  },
  function () {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "section-header" }, [
      _c("h4", [_vm._v("Tehlikeli Alan")]),
      _vm._v(" "),
      _c("p", [_vm._v("Bu işlemler geri alınamaz")]),
    ])
  },
  function () {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "danger-info" }, [
      _c("div", { staticClass: "danger-title" }, [
        _vm._v("Kanalı Devre Dışı Bırak"),
      ]),
      _vm._v(" "),
      _c("div", { staticClass: "danger-desc" }, [
        _vm._v("Kanal geçici olarak devre dışı bırakılır"),
      ]),
    ])
  },
  function () {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "danger-info" }, [
      _c("div", { staticClass: "danger-title" }, [_vm._v("Kanalı Sil")]),
      _vm._v(" "),
      _c("div", { staticClass: "danger-desc" }, [
        _vm._v("Kanal kalıcı olarak silinir"),
      ]),
    ])
  },
]
render._withStripped = true

export { render, staticRenderFns }